import { render, staticRenderFns } from "./Wap_JLCT82_Step3.vue?vue&type=template&id=37c20b6d&scoped=true&"
import script from "./Wap_JLCT82_Step3.vue?vue&type=script&lang=js&"
export * from "./Wap_JLCT82_Step3.vue?vue&type=script&lang=js&"
import style0 from "./Wap_JLCT82_Step3.vue?vue&type=style&index=0&id=37c20b6d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c20b6d",
  null
  
)

export default component.exports